export const START_DATE = '2016-02-27 22:00:00'
export const GOOGLE_MAPS_TOKEN = 'AIzaSyCeB9572RDKVdzEJaLEBNrCFspFrguMlsg'
export const TRIPS = [{
  title: 'Berlin',
  from: '2016-10-02',
  to: '2016-10-06',
  map: 'place_id:ChIJAVkDPzdOqEcRcDteW0YgIQQ'
}, {
  title: 'Copenhagen',
  from: '2017-10-15',
  to: '2017-10-19',
  map: 'Copenhagen',
}, {
  title: 'Amsterdam',
  from: '2017-10-19',
  to: '2017-10-22',
  map: 'Amsterdam',
}, {
  title: 'Valencia',
  from: '2018-01-19',
  to: '2018-01-23',
  map: 'Valencia',
}, {
  title: 'Geneva',
  from: '2018-07-13',
  to: '2018-07-13',
  map: 'Geneva',
}, {
  title: 'Verbier',
  from: '2018-07-13',
  to: '2018-07-14',
  map: 'Verbier',
}, {
  title: 'Aosta',
  from: '2018-07-14',
  to: '2018-07-16',
  map: 'Aosta',
}, {
  title: 'Turin',
  from: '2018-07-16',
  to: '2018-07-18',
  map: 'Turin',
}, {
  title: 'Chamonix',
  from: '2018-07-18',
  to: '2018-07-18',
  map: 'Chamonix',
}, {
  title: 'Geneva',
  from: '2018-07-18',
  to: '2018-07-18',
  map: 'Geneva',
}, {
  title: 'Seoul',
  from: '2018-10-26',
  to: '2018-10-30',
  map: 'Seoul',
}, {
  title: 'Tokyo',
  from: '2018-10-30',
  to: '2018-11-04',
  map: 'Tokyo',
}, {
  title: 'San Francisco',
  from: '2019-03-13',
  to: '2019-03-19',
  map: 'San%20Francisco',
}, {
  title: 'Berlin',
  from: '2020-02-13',
  to: '2020-02-16',
  map: 'place_id:ChIJAVkDPzdOqEcRcDteW0YgIQQ'
}, {
  title: 'Lake Como',
  from: '2022-06-22',
  to: '2022-06-26',
  map: 'Lake%20Como'
}, {
  title: 'Helsingborg',
  from: '2022-12-29',
  to: '2023-01-02',
  map: 'Helsingborg'
}, {
  title: 'Berlin',
  from: '2023-09-21',
  to: '2023-09-24',
  map: 'place_id:ChIJAVkDPzdOqEcRcDteW0YgIQQ'
}, {
  title: 'Keukenhof 💍',
  from: '2024-04-04',
  to: '2024-04-06',
  map: 'Keukenhof'
}, {
  title: 'Mirepoix',
  from: '2024-05-21',
  to: '2024-05-24',
  map: 'Mirepoix'
}, {
  title: 'Skiathos',
  from: '2024-06-04',
  to: '2024-06-11',
  map: 'Skiathos'
}, {
  title: 'Cephalonia',
  from: '2025-06-12',
  to: '2025-06-19',
  map: 'Cephalonia'
}]


